export enum ApplicantSkillLevel {
  NOT_EXISTING = 'not-existing',
  EXISTING = 'existing',
  FUNDAMENTAL = 'fundamental',
  FUNDAMENTAL_PLUS = 'fundamental-plus',
  GOOD = 'good',
  VERY_GOOD = 'very-good',
  EXPERT = 'expert',
}
